import React from 'react';
import { MessageSquare } from 'lucide-react';

interface AfterHoursSectionProps {
  autoReplyEnabled: boolean;
  autoReplyMessage: string;
  themePrimary: string;
  themeBorder: string;
  onToggleAutoReply: () => void;
  onAutoReplyMessageChange: (v: string) => void;
}

export function AfterHoursSection({
  autoReplyEnabled,
  autoReplyMessage,
  themePrimary,
  themeBorder,
  onToggleAutoReply,
  onAutoReplyMessageChange,
}: AfterHoursSectionProps) {
  return (
    <div className="bg-card-background rounded-lg border border-border p-6">
      <div className="flex items-center mb-6">
        <MessageSquare className="h-5 w-5 text-text-secondary mr-2" />
        <h2 className="text-lg font-medium text-text-primary">After-Hours Response</h2>
      </div>

      <div className="space-y-4">
        {/* Auto-reply toggle */}
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-sm font-medium text-text-primary">Auto-reply message</h3>
            <p className="text-sm text-text-secondary">Send an automatic reply after business hours</p>
          </div>
          <button
            onClick={onToggleAutoReply}
            className="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out focus:outline-none"
            style={{
              backgroundColor: autoReplyEnabled ? themePrimary : themeBorder
            }}
            role="switch"
            aria-checked={autoReplyEnabled}
          >
            <span
              className={`pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out absolute top-1 left-1 ${
                autoReplyEnabled ? 'translate-x-5' : 'translate-x-0'
              }`}
            />
          </button>
        </div>

        {/* Message customization */}
        {autoReplyEnabled && (
          <div className="space-y-3">
            <label htmlFor="auto-reply-message" className="block text-sm font-medium text-text-primary">
              Custom message
            </label>
            <textarea
              id="auto-reply-message"
              rows={4}
              value={autoReplyMessage}
              onChange={(e) => onAutoReplyMessageChange(e.target.value)}
              className="input"
              style={{ '--tw-ring-color': themePrimary } as React.CSSProperties}
              placeholder="Enter your after-hours auto-reply message..."
            />
            <p className="text-xs text-text-secondary">
              This message will be sent automatically when clients contact you outside of business hours.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
